import React from "react";

export default function FloatingButtons() {
  return (
    <div className="floating-buttons">
      <a
        href="oussamachaoui922@gmail.com"
        className="floating-btn email-btn"
        aria-label="Send Email"
      >
        Email
      </a>

      <a
        href="https://wa.me/212640783502"
        target="_blank"
        rel="noreferrer"
        className="floating-btn whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        WhatsApp
      </a>
    </div>
  );
}